import UserManagementPage from "../../../shared/UserManagementPage";

export default function ManufacturingUserManagement() {
  return <UserManagementPage showActivityReport={false} showViewProfile={false} />;
}
